import { RootState } from 'store';

export const isInternetExplorer = (state: RootState) => state.internetExplorer;
